<template>
  <div id="app">
    <div id="viewer"></div>
  </div>
</template>

<script>

export default {
  name: 'report-viewer',
  components: {},

  props: {
    fileName: {
      type: String,
      default: null
    },
    report: {
      type: String,
      default: null
    },
    dataSets: {
      type: Array,
      default:  () => []
    }
  },

  watch: {
    reportName() {
      this.render();
    },
    dataSets() {
      this.render();
    }
  },

  methods: {
    render() {
      window.Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile("stimulsoft/Localizations/ru.xml");

      var options = new window.Stimulsoft.Viewer.StiViewerOptions();
      options.appearance.scrollbarsMode = true;
      options.appearance.pageBorderColor = window.Stimulsoft.System.Drawing.Color.navy;
      options.toolbar.borderColor = window.Stimulsoft.System.Drawing.Color.navy;
      options.toolbar.showPrintButton = true;
      options.toolbar.showViewModeButton = true;
      options.toolbar.viewMode = window.Stimulsoft.Viewer.StiWebViewMode.Continuous;
      options.toolbar.zoom = 100;

      var viewer = new window.Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false)
      var report = new window.Stimulsoft.Report.StiReport()
      report.load(this.report)
     
      report.reportName = this.fileName

      if(this.dataSets && this.dataSets.length>0) {
        report.dictionary.databases.clear();

        this.dataSets.forEach((el) => {
          var dataSet = new window.Stimulsoft.System.Data.DataSet(el.name);
          let json = JSON.stringify(el.tables)
          //console.log(json)
          dataSet.readJson(json)
          report.regData(dataSet.dataSetName, dataSet.dataSetName, dataSet);
        })
      }

      viewer.report = report
      viewer.renderHtml('viewer');
    }
  },

  mounted() {
    this.render()
  }
}

</script>

